<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="26" viewBox="0 0 15 26" fill="none">
    <path d="M14 0.771484L2 12.7715L14 24.7715" stroke="black" stroke-width="2"/>
  </svg>
</template>